"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initFilters = void 0;
var React = __importStar(require("react"));
var useMemo = React.useMemo, useState = React.useState;
var defaultFilter = 'All Products';
var filterPrefix = 'Bundler App Filter - ';
// tags from the API are a string, from liquid are an array
var tagsAsArray = function (tags) { return (typeof tags === 'string' ? tags.split(', ') : tags); };
var initFilters = function (addOns) {
    // build the array of filters from the tags on the products
    var filters = useMemo(function () {
        return addOns.reduce(function (arr, _a) {
            var e_1, _b;
            var product = _a.product;
            try {
                for (var _c = __values(tagsAsArray(product.tags)), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var tagWithPrefix = _d.value;
                    if (tagWithPrefix.startsWith(filterPrefix)) {
                        var tag = tagWithPrefix.replace(filterPrefix, '');
                        if (!arr.includes(tag))
                            arr.push(tag);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return arr;
        }, [defaultFilter]);
    }, [addOns]);
    var _a = __read(useState(defaultFilter), 2), activeFilter = _a[0], setActiveFilter = _a[1];
    var filteredProducts = useMemo(function () {
        return activeFilter === defaultFilter
            ? addOns
            : addOns.filter(function (_a) {
                var product = _a.product;
                return tagsAsArray(product.tags).some(function (t) { return activeFilter.includes(t.replace(filterPrefix, '')); });
            });
    }, [addOns, activeFilter]);
    // helper function to render the horizontal list of filters
    var renderFilters = function () {
        return filters.length && (React.createElement("div", { className: 'horizontal-scroll margin-vertical-3' }, filters.map(function (filter) {
            var isActive = activeFilter.includes(filter);
            return (React.createElement("div", { className: 'display-inline-block margin-right-4', key: "filter-".concat(filter) },
                React.createElement("div", { className: 'button rounded padding-horizontal-5', style: { backgroundColor: isActive ? '#e8d9ed' : '#f1f1f1' }, onClick: function () { return setActiveFilter(filter); } },
                    React.createElement("span", { className: isActive ? 'text-wisteria' : 'text-nobel' }, filter))));
        })));
    };
    return { filteredProducts: filteredProducts, renderFilters: renderFilters, activeFilter: activeFilter };
};
exports.initFilters = initFilters;
